<template>
    <div id="rate_create" class="fleet-form-main">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="customerHeader1" v-if="isEdit" >Update Rate</span>
                <span class="page-title" id="customerHeader2"  v-else>Add Rate</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                    <i class="fp-back"> </i>  Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="from-group">
                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <strong id="errorMsg" class="field-error"></strong>
                    </div>
                </div>
                <div class="admin-page-content customer-crud">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="needs-validation" novalidate id="RateForm">
                            <div class="form-row">
                                <div class="col-4 form-group">
                                    <label class="control-label require" for="warranty_user_id">Select Warranty Dealer:</label>
                                    <v-select v-model="warranty_user_id"
                                            name="warranty_user_id"
                                            label="text"
                                            :filterable="false"
                                            :options="warrantyUsers"
                                            @search="onSearchWarrantyUser"
                                            placeholder="Select User"
                                            class="custom-ci-auto-search"
                                            :disabled="disableFields"
                                            @input="onWarrantyDealerChange">
                                    <template slot="no-options">
                                        Search User...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                        {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                        {{ option.text }}
                                        </div>
                                    </template>
                                    </v-select>
                                    <div class="field-error">{{ warranty_user_id_error_msg }}</div>
                                </div>
                                <div class="col-4 form-group">
                                    <label class="control-label require" for="Labor Rate">Labor Rate:</label>
                                    <input type="number" class="form-control" v-model="labor_rate" id="Labor Rate" placeholder="Labor Rate" name="labor_rate">
                                    <span class="field-error">{{ labor_rate_error_msg }}</span>
                                </div>
                                <div class="col-4 form-group">
                                    <label class="control-label require" for="Travel Rate">Travel Rate:</label>
                                    <input type="number" class="form-control" v-model="travel_rate" id="Travel Rate" placeholder="Travel Rate" name="travel_rate">
                                    <span class="field-error">{{ travel_rate_error_msg }}</span>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-4 form-group">
                                    <label class="control-label require" for="labor_effective_date">Labor rate effective date:</label>
                                    <div class="input-group">
                                    <date-picker placeholder="MM/DD/YYYY" id="labor_effective_date" name="labor_effective_date"
                                                v-model="labor_effective_date"
                                                :config="options"></date-picker>
                                    <label for="labor_effective_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ labor_rate_effective_date_error_msg }}</div>
                                </div>
                                <div class="col-4 form-group">
                                    <label class="control-label require" for="travel_effective_date">Travel rate effective date:</label>
                                    <div class="input-group">
                                    <date-picker placeholder="MM/DD/YYYY" id="travel_effective_date" name="travel_effective_date"
                                                v-model="travel_effective_date"
                                                :config="options"></date-picker>
                                    <label for="travel_effective_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ travel_rate_effective_date_error_msg }}</div>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" id="CreateRateBtn" v-if="isEdit" class="btn btn-primary" v-on:click.prevent="CreateRate" >
                                    <i class="fp-reload"> </i>  Update
                                </button>
                                <button type="submit" id="CreateRateBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateRate" >
                                    <i class="fp-save"> </i>  Save
                                </button>
                                <button  type="submit" id="createAndContinueRateBtn" v-if="!isEdit" class="btn btn-tertiary" v-on:click.prevent="CreateRate(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                </button>
                                <button type="submit" id="cancelRateBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                                    <i class="fp-close"> </i>  Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
            <div class="bg-white text-center">
              <h1>
                Oops!</h1>
              <h2>
                403 </h2>
              <div class="error-details">
                Sorry!, You don't have permission to access this page.
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
      </div>
    </div>
</template>
<script>
  import {commonMixins} from '../../mixins/commonMixins';
  import {contractMixins} from '../../mixins/contractMixins';

  export default {
    name: "RatesCreate",
    metaInfo() {
      return {
        title: (this.isEdit == true)? "Update Rate | " + process.env.COPYRIGHT_NAME : "Create Rate | " +process.env.COPYRIGHT_NAME
      }
    },

    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading: false,
        warranty_user_id: 0,
        warranty_user_id_error_msg: "",
        warrantyUsers: [],
        labor_rate: "",
        travel_rate: "",
        labor_effective_date: "",
        labor_rate_effective_date_error_msg: "",
        travel_effective_date: "",
        travel_rate_effective_date_error_msg: "",
        options: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        labor_rate_error_msg: "",
        travel_rate_error_msg: "",
        rateId: 0,
        errorMsg: "",
        disableFields: false,
        isEdit: false,
    }),

    watch:{
      //check permission change
      permissions: function (permissions) {
        var self = this;
        if (permissions.length > 0) {
          for (var i = 0; i < permissions.length; i++) {
            if (permissions[i].name == 'ev_add_rate' || permissions[i].name == 'ev_edit_rate') {
              self.cantAccessPage = true;
            }
          }
        }
      },
    },
    mounted: function() {
        var self = this;
        self.getPermissions();

        if (self.$route.params.id !== undefined && self.$route.params.id > 0) {
            self.disableFields = true;
            self.rateId = self.$route.params.id;
            self.loadSingleRate();
        }
    },
    methods: {
        onSearchWarrantyUser(search, loading) {
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'warranty_user', '');
            }
        },
        validateFields(){
            var self = this;
            self.warranty_user_id_error_msg = "";
            self.labor_rate_error_msg = "";
            self.travel_rate_error_msg = "";
            self.labor_rate_effective_date_error_msg = "";
            self.travel_rate_effective_date_error_msg = "";

            var error = false;
            if(self.warranty_user_id == 0 || self.warranty_user_id == ""){
                self.warranty_user_id_error_msg = "Warranty Dealer is Required";
                error = true;
            }

            if(self.labor_rate == 0 || self.labor_rate == ""){
                self.labor_rate_error_msg = "Labor Rate is Required";
                error = true;
            }

            if(self.travel_rate == 0 || self.travel_rate == ""){
                self.travel_rate_error_msg = "Travel Rate is Required";
                error = true;
            }

            if (self.labor_effective_date == null || self.labor_effective_date == '') {
                self.labor_rate_effective_date_error_msg = "Labor Effective Date is Required.";
                error = true;
            }

            if (self.travel_effective_date == null || self.travel_effective_date == '') {
                self.travel_rate_effective_date_error_msg = "Travel Effective Date is Required.";
                error = true;
            }

            return error;
        },
        CreateRate(flag){
            var self = this;
            var error = self.validateFields();
            if(!error){
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/rate/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        rate_id: self.rateId,
                        warranty_user_id : self.warranty_user_id.value,
                        labor_rate: self.labor_rate,
                        travel_rate: self.travel_rate,
                        labor_effective_date: self.labor_effective_date,
                        travel_effective_date: self.travel_effective_date
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if(data.status == 'success'){
                            if(flag == "Save and Continue"){
                                $("#RateForm").trigger("reset");
                                self.warranty_user_id = "";
                                self.labor_rate = "";
                                self.travel_rate = "";
                                self.labor_effective_date = "";
                                self.travel_effective_date = "";
                            }else{
                                self.$router.push("/rates/list");
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                });
            }
        },
        loadSingleRate() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/rate/" + self.rateId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.isEdit = true;
                        self.warranty_user_id = {text:data.content.warranty_dealer_name,value:data.content.warranty_user_id};
                        self.labor_rate = data.content.labor_rate;
                        self.travel_rate = data.content.travel_rate;
                        self.labor_effective_date = data.content.labor_effective_date;
                        self.travel_effective_date = data.content.travel_effective_date;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        },
        onWarrantyDealerChange(value){
            var self = this;
            if(value == null){
                self.isEdit = false;
                self.rateId = 0;
                self.warranty_user_id = "";
                self.labor_rate = "";
                self.travel_rate = "";
                self.labor_effective_date = "";
                self.travel_effective_date = "";
            }else{
                self.checkWarrantyDealer();
            }
        },
        checkWarrantyDealer(){
            var self = this;
            if(self.warranty_user_id.value != null && self.warranty_user_id.value > 0){
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/rate-check-warranty-user/" + self.warranty_user_id.value,
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.isEdit = true;
                            self.rateId = data.content.id;

                            self.labor_rate = data.content.labor_rate;
                            self.travel_rate = data.content.travel_rate;
                            self.labor_effective_date = data.content.labor_effective_date;
                            self.travel_effective_date = data.content.travel_effective_date;
                        }else{
                            self.isEdit = false;
                            self.rateId = 0;
                            self.labor_rate = "";
                            self.travel_rate = "";
                            self.labor_effective_date = "";
                            self.travel_effective_date = "";
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 5000);
                        }
                    }
                });
            }
        },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/rate/RatesCreate.vue